import { Type } from "class-transformer";
import { EnaioAssignment } from "src/modules/enaio/shared/EnaioAssignment";
import { EnaioTableAssignment } from "src/modules/enaio/shared/EnaioTableAssignment";

export class EnaioFrontendInsertData {
    defId = "";
    parentId = 0;
    @Type(() => EnaioAssignment)
    fields: EnaioAssignment[];
    @Type(() => EnaioTableAssignment)
    tableFields: EnaioTableAssignment[];
    documentFileName: string;
    documentBase64: string;
}
